import styled from 'styled-components';
import { Modal, spacing, Box, InputGroup, Button } from '@landr/maestro';

const ShareModal = styled(Modal)`
    height: 292px; /* @maestro-no-token */
`;

const ModalContent = styled(Modal.Content)`
    display: flex;
    flex-direction: column;
    padding: ${spacing('xl')} ${spacing('xxl')};
`;

const TitleContainer = styled(Box)`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${spacing('xl')};
`;

const CopyButton = styled(Button)`
    width: 72px; /* @maestro-no-token */
    > svg {
        margin: 0 !important; /* @maestro-no-token - overrides are not applied */
    }
`;

const CopyInputGroup = styled(InputGroup)`
    width: 100%;
`;

export const Styled = {
    TitleContainer,
    ShareModal,
    ModalContent,
    CopyButton,
    CopyInputGroup,
};
